import { Controller } from "@hotwired/stimulus"

// Keeps the demo configurator's sidebar stepper highlight in sync when the
// visitor switches documents via a step, Back, or Next click.
//
// The actual document-panel switching is handled by the SHARED
// template-questionnaire#switchDocument action (which we must not modify).
// That controller only re-renders on answer changes, so a pure step/Back/Next
// click would otherwise leave the sidebar highlight stale. This isolated
// controller just moves the visual "active step" marker; it holds no other
// state and is safe to attach alongside template-questionnaire.
export default class extends Controller {
  static targets = ["step"]

  activate(event) {
    const id = event.currentTarget.dataset.stepDocumentId
    if (!id) return
    this.stepTargets.forEach((marker) => {
      this.setActive(marker, marker.dataset.stepDocumentId === id)
    })
  }

  // Each step target IS the numbered marker button, so toggle classes on it
  // directly (not on descendants).
  setActive(marker, active) {
    marker.classList.toggle("border-ps-blue", active)
    marker.classList.toggle("text-ps-blue", active)
    marker.classList.toggle("bg-white", active)
    marker.classList.toggle("border-gray-200", !active)
    marker.classList.toggle("bg-gray-100", !active)
    marker.classList.toggle("text-gray-400", !active)
  }
}
